
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6JN6z", function(module, exports) {

$parcel$export(module.exports, "BanditsProvider", function () { return $54ee6c432cc378b8$export$ed6616ed0f76d929; });
$parcel$export(module.exports, "BanditsHeaderWrapper", function () { return $54ee6c432cc378b8$export$1cb749e21ac9e393; });
$parcel$export(module.exports, "BanditsAssetWrapper", function () { return $54ee6c432cc378b8$export$f9fbacfdb5ded657; });
/* bandits-components.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hjMWG = parcelRequire("hjMWG");

var $bhreu = parcelRequire("bhreu");

var $jbZl4 = parcelRequire("jbZl4");

var $gFK1O = parcelRequire("gFK1O");
const $54ee6c432cc378b8$var$BanditsContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    banditsContent: null,
    loading: false,
    error: null
});
const $54ee6c432cc378b8$export$ed6616ed0f76d929 = ({ product: product, keyword: keyword, isExperimentEnabled: isExperimentEnabled = false, children: children })=>{
    const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
    const [banditsContent, setBanditsContent] = (0, $iSvIT.useState)(isExperimentEnabled ? null : (0, $jbZl4.nullBanditsContent));
    const [loading, setLoading] = (0, $iSvIT.useState)(isExperimentEnabled);
    const [error, setError] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!isExperimentEnabled) return;
        const getBanditsContent = async ()=>{
            const content = await (0, $jbZl4.getGrsAndContentfulContent)({
                keyword: keyword || "",
                product: product,
                locale: "en-US",
                anonymousId: anonymousId
            });
            if (content === null || content === void 0 ? void 0 : content.recoSessionId) (0, $jbZl4.setGrsDataToLocalStorage)({
                recoSessionId: content.recoSessionId,
                recoEntityId: content.recoEntityId
            });
            setBanditsContent(content);
        };
        try {
            getBanditsContent();
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        isExperimentEnabled,
        keyword,
        product,
        anonymousId
    ]);
    const value = (0, $iSvIT.useMemo)(()=>({
            banditsContent: banditsContent,
            loading: loading,
            error: error
        }), [
        banditsContent,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($54ee6c432cc378b8$var$BanditsContext.Provider, {
        value: value,
        children: children
    });
};
const $54ee6c432cc378b8$export$d85787cef2955e0c = ()=>{
    const context = (0, $iSvIT.useContext)($54ee6c432cc378b8$var$BanditsContext);
    if (!context) console.info("useBanditsContext is not used within a BanditsProvider");
    return context;
}; // Wrapper Components
const $54ee6c432cc378b8$var$imgContainer = null;
const $54ee6c432cc378b8$var$confluenceImgContainer = null;
const $54ee6c432cc378b8$export$1cb749e21ac9e393 = ({ product: product, type: type = "header", children: children })=>{
    var _banditsContent_headline, _banditsContent_headline1;
    const { banditsContent: banditsContent, loading: loading, error: error } = $54ee6c432cc378b8$export$d85787cef2955e0c();
    const SkeletonComponent = product === "jira" ? $54ee6c432cc378b8$export$15339ba7c5b3a2b8 : $54ee6c432cc378b8$export$ce1a828edc281b5e;
    if (loading || !banditsContent) return /*#__PURE__*/ (0, $loA2J.jsx)(SkeletonComponent, {
        type: type
    });
    if (error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.headline)) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: type === "header" ? banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline = banditsContent.headline) === null || _banditsContent_headline === void 0 ? void 0 : _banditsContent_headline.title : banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline1 = banditsContent.headline) === null || _banditsContent_headline1 === void 0 ? void 0 : _banditsContent_headline1.subheading
    });
}; // eslint-disable-next-line complexity
const $54ee6c432cc378b8$export$f9fbacfdb5ded657 = ({ product: product, showChildren: showChildren = false, children: children })=>{
    var _banditsContent_asset, _banditsContent_asset1, _banditsContent_asset_video1Mp4, _banditsContent_asset2, _banditsContent_asset_image1, _banditsContent_asset3, _banditsContent_asset_video1Mp41, _banditsContent_asset4, _banditsContent_asset_video1Webm, _banditsContent_asset5, _banditsContent_asset_image11, _banditsContent_asset6, _banditsContent_asset_image12, _banditsContent_asset7;
    const { banditsContent: banditsContent, loading: loading, error: error } = $54ee6c432cc378b8$export$d85787cef2955e0c();
    if (loading || !banditsContent) return /*#__PURE__*/ (0, $loA2J.jsx)($54ee6c432cc378b8$export$8a7df558a5bc35a7, {});
    if (showChildren || error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.asset) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset = banditsContent.asset) === null || _banditsContent_asset === void 0 ? void 0 : _banditsContent_asset.id) === (0, $jbZl4.JIRA_FEATURES_ASSET_CONTROL) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset1 = banditsContent.asset) === null || _banditsContent_asset1 === void 0 ? void 0 : _banditsContent_asset1.id) === (0, $jbZl4.CONFLUENCE_FEATURES_ASSET_CONTROL)) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _c71lstmo _1bsb1osq _p12f1kpv",
            product === "confluence" && "_1ul91178 _p12f1osq _16jlkb7n _1o9zkb7n _i0dl1osq _sugaglyw"
        ]),
        children: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset2 = banditsContent.asset) === null || _banditsContent_asset2 === void 0 ? void 0 : (_banditsContent_asset_video1Mp4 = _banditsContent_asset2.video1Mp4) === null || _banditsContent_asset_video1Mp4 === void 0 ? void 0 : _banditsContent_asset_video1Mp4.url) ? /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            preload: "auto",
            poster: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset3 = banditsContent.asset) === null || _banditsContent_asset3 === void 0 ? void 0 : (_banditsContent_asset_image1 = _banditsContent_asset3.image1) === null || _banditsContent_asset_image1 === void 0 ? void 0 : _banditsContent_asset_image1.url,
            controls: true,
            className: (0, $esG4f.default)([
                "_c71lcv93 _p12f1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset4 = banditsContent.asset) === null || _banditsContent_asset4 === void 0 ? void 0 : (_banditsContent_asset_video1Mp41 = _banditsContent_asset4.video1Mp4) === null || _banditsContent_asset_video1Mp41 === void 0 ? void 0 : _banditsContent_asset_video1Mp41.url,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset5 = banditsContent.asset) === null || _banditsContent_asset5 === void 0 ? void 0 : (_banditsContent_asset_video1Webm = _banditsContent_asset5.video1Webm) === null || _banditsContent_asset_video1Webm === void 0 ? void 0 : _banditsContent_asset_video1Webm.url,
                    type: "video/webm"
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset6 = banditsContent.asset) === null || _banditsContent_asset6 === void 0 ? void 0 : (_banditsContent_asset_image11 = _banditsContent_asset6.image1) === null || _banditsContent_asset_image11 === void 0 ? void 0 : _banditsContent_asset_image11.url) || "",
                alt: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset7 = banditsContent.asset) === null || _banditsContent_asset7 === void 0 ? void 0 : (_banditsContent_asset_image12 = _banditsContent_asset7.image1) === null || _banditsContent_asset_image12 === void 0 ? void 0 : _banditsContent_asset_image12.description) || ""
            },
            className: (0, $esG4f.default)([
                "_c71lcv93"
            ])
        })
    });
}; // Skeleton Components
const $54ee6c432cc378b8$var$sectionGap = null;
const $54ee6c432cc378b8$var$desktopDisplay = null;
const $54ee6c432cc378b8$var$tabletDisplay = null;
const $54ee6c432cc378b8$var$mobileDisplay = null;
const $54ee6c432cc378b8$var$containerStyles = null;
const $54ee6c432cc378b8$export$15339ba7c5b3a2b8 = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "hero-header-skeleton",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "420px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "360px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "680px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "460px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "320px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "280px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "240px",
                                height: "64px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $54ee6c432cc378b8$export$ce1a828edc281b5e = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "280px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "300px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "320px",
                    height: "32px"
                })
            })
        ]
    });
};
const $54ee6c432cc378b8$export$8a7df558a5bc35a7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "hero-asset-skeleton",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "600px",
                    height: "480px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "420px",
                    height: "280px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "250px",
                    height: "200px"
                })
            })
        ]
    });
};

});

parcelRegister("47Euo", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("jqbIe")).Dropdown; });
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return (parcelRequire("hFZ05")).useSiteActivationContext; });

$parcel$export(module.exports, "default", function () { return $a2fbbb40a532c3c3$export$2e2bcd8739ae039; });

var $4IavQ = parcelRequire("4IavQ");
parcelRequire("dhiHj");
parcelRequire("biQJa");
var $a2fbbb40a532c3c3$export$2e2bcd8739ae039 = (0, $4IavQ.SiteActivation);

});
parcelRegister("4IavQ", function(module, exports) {

$parcel$export(module.exports, "SiteActivation", function () { return $ded2e4e9460465e4$export$5f19f51fdf3d70; });
/* site-activation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");

var $lXhsL = parcelRequire("lXhsL");
const $ded2e4e9460465e4$export$5f19f51fdf3d70 = (props)=>{
    const cohort = (0, $iMdoL.useCohort)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "site-activation",
        "data-cohort": cohort,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFZ05.SiteActivationContextProvider), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXhsL.SiteActivationSwitcher), (0, $7Knp0._)({}, props))
        })
    });
};
// fill the available space in the parent container
const $ded2e4e9460465e4$var$siteActivationCss = null;

});
parcelRegister("biQJa", function(module, exports) {
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return (parcelRequire("hFZ05")).SiteActivationContextProvider; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return (parcelRequire("hFZ05")).useSiteActivationContext; });
parcelRequire("hSQrG");
parcelRequire("hFZ05");

});
parcelRegister("hSQrG", function(module, exports) {

$parcel$export(module.exports, "useRecommendedSiteName", function () { return $c5ced0576bd99bf0$export$c2aa7c9492b42e56; });

var $iSvIT = parcelRequire("iSvIT");

var $aYwtv = parcelRequire("aYwtv");

var $5wOn9 = parcelRequire("5wOn9");

var $hFZ05 = parcelRequire("hFZ05");
function $c5ced0576bd99bf0$export$c2aa7c9492b42e56(props = {}) {
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, recommendedSiteName: recommendedSiteName } = (0, $hFZ05.useSiteActivationContext)();
    const [siteNamePopulated, setSiteNamePopulated] = (0, $iSvIT.useState)();
    const client = (0, $aYwtv.useBxpWebStargateClient)();
    const user = (0, $5wOn9.useLoggedInUser)();
    const email = user === null || user === void 0 ? void 0 : user.email;
    (0, $iSvIT.useEffect)(()=>{
        if (email) client.getRecommendedSiteName({
            email: email
        }).then((result)=>setSiteNameValue(result.recommendedName)).catch(props.onError);
    }, [
        client,
        email,
        props.onError,
        setSiteNameValue
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (siteNamePopulated) // take no action because site name was already changed via either user interaction or site-name recommendation
        return;
        if (siteName) // user has already started typing, let's not overwrite their input with a recommended site name
        setSiteNamePopulated(true);
        else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [
        siteNamePopulated,
        recommendedSiteName,
        siteName,
        setSiteNameValue
    ]);
}

});
parcelRegister("hFZ05", function(module, exports) {

$parcel$export(module.exports, "useSiteActivationContext", function () { return $ea14a84f25ad216e$export$48473054405e7add; });
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return $ea14a84f25ad216e$export$e1087d57f38afae1; });
//TO DO: in the next PR refactor and test this context

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $cGDYS = parcelRequire("cGDYS");

var $g9kzu = parcelRequire("g9kzu");

var $jFQmg = parcelRequire("jFQmg");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $aYwtv = parcelRequire("aYwtv");

var $3FBn4 = parcelRequire("3FBn4");

var $gFK1O = parcelRequire("gFK1O");

var $gAJUc = parcelRequire("gAJUc");

var $lrVTP = parcelRequire("lrVTP");

var $dwSjs = parcelRequire("dwSjs");

var $fBroD = parcelRequire("fBroD");
const { ABORTED: $ea14a84f25ad216e$var$ABORTED, SUCCEEDED: $ea14a84f25ad216e$var$SUCCEEDED } = (0, $jgJpJ.UfoExperienceStatus);
const { PRESS: $ea14a84f25ad216e$var$PRESS, TRANSITION: $ea14a84f25ad216e$var$TRANSITION } = (0, $jgJpJ.UfoInteractionType);
const $ea14a84f25ad216e$var$ufoBaseLogs = [
    {
        name: "pkg:site-activation"
    },
    {
        name: "component:siteActivationContextProvider"
    }
];
const $ea14a84f25ad216e$export$fe5d808150ab3415 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $ea14a84f25ad216e$export$48473054405e7add = ()=>{
    const context = (0, $iSvIT.useContext)($ea14a84f25ad216e$export$fe5d808150ab3415);
    if (!context) throw new Error("useSiteActivationContext must be used within a SiteActivationContextProvider");
    return context;
};
const $ea14a84f25ad216e$export$e1087d57f38afae1 = ({ children: children })=>{
    var _transactionAccounts_, _profile_cohorts, _location_pathname;
    //HOOKS
    const intl = (0, $f6qj2.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const signupClient = (0, $aYwtv.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const { profile: profile, user: user, product: product, edition: originalEdition = "free", transactionAccounts: transactionAccounts } = (0, $iMdoL.useUserContext)();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if ((product === null || product === void 0 ? void 0 : product.key) === (0, $jgJpJ.ProductKey).DEVAI) edition = "standard";
    const { companyType: companyType, domainType: domainType, userType: userType } = (profile === null || profile === void 0 ? void 0 : profile.cohorts) || {};
    const cohort = (0, $iMdoL.useCohort)();
    const expandableSites = (0, $iMdoL.useCrossflowEligibleSites)();
    const upgradableSites = (0, $iMdoL.useUpgradableSites)();
    const stargateClient = (0, $aYwtv.useBxpWebStargateClient)();
    const location = (0, $lrVTP.useLocation)();
    const sites = (0, $iSvIT.useMemo)(()=>{
        var _ref;
        return (_ref = cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER ? upgradableSites : expandableSites) !== null && _ref !== void 0 ? _ref : [];
    }, [
        cohort,
        expandableSites,
        upgradableSites
    ]);
    const isWorkspaceProduct = (0, $iSvIT.useMemo)(()=>!!(product === null || product === void 0 ? void 0 : product.key) && [
            (0, $jgJpJ.ProductKey).CONFLUENCE,
            (0, $jgJpJ.ProductKey).TEAMWORK_COLLECTION,
            (0, $jgJpJ.ProductKey).SERVICE_COLLECTION
        ].includes(product === null || product === void 0 ? void 0 : product.key), [
        product === null || product === void 0 ? void 0 : product.key
    ]);
    //STATE
    const [showSitePicker, setShowSitePicker] = (0, $iSvIT.useState)(sites.length > 0);
    const [siteNameValid, setSiteNameValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [sitePickerValue, setSitePickerValue] = (0, $iSvIT.useState)(sites[0]);
    const [siteName, setSiteNameValue] = (0, $iSvIT.useState)("");
    const [recommendedSiteName] = (0, $iSvIT.useState)("");
    var _transactionAccounts__id;
    const [selectedTransactionAccountId, setSelectedTransactionAccountId] = (0, $iSvIT.useState)((_transactionAccounts__id = (_transactionAccounts_ = transactionAccounts[0]) === null || _transactionAccounts_ === void 0 ? void 0 : _transactionAccounts_.id) !== null && _transactionAccounts__id !== void 0 ? _transactionAccounts__id : "");
    const [recaptchaFailedToLoad, setRecaptchFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const [validatationMessage, setValidationMessage] = (0, $iSvIT.useState)();
    //VARIABLES
    const searchParameters = new URLSearchParams(location.search);
    var _searchParameters_get;
    const platform = (_searchParameters_get = searchParameters.get("platform")) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : "routing";
    const primaryCollectionProduct = searchParameters.get("primaryCollectionProduct");
    const localizedContactUrl = (0, $3FBn4.useLocalizedHref)("/company/contact");
    const isNewUser = ((_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType) === "new-user";
    const productKey = product === null || product === void 0 ? void 0 : product.key;
    const { isValid: isValid, isValidating: isValidating, error: error } = (0, $dwSjs.useSiteNameValidation)(siteName, setSiteNameValid);
    const isEmbedded = !((_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.endsWith("/try/cloud/signup"));
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const redirectToAdminHubForShadowIt = (error)=>{
        var _error_response;
        const errorCode = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status;
        const redirectUrlShadowIt = errorCode === 403 && (0, $jgJpJ.getRedirectUrlFromShadowItError)(error);
        // Shadow IT unauthorized user redirects to adminhub's Shadow IT request flow.
        if (errorCode === 403 && Boolean(redirectUrlShadowIt)) window.location.assign(redirectUrlShadowIt);
    };
    const showRecaptchaFormError = (0, $iSvIT.useCallback)(()=>{
        const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "n/a");
        setValidationMessage((0, $6iHNw._)((0, $7Knp0._)({}, (0, $fBroD.messages).timeout), {
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                "href-support": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                "error_id": `Anonymous ID: ${anonymousId}`
            }
        }));
        // Reset form to allow re-submit
        setIsSubmitting(false);
        setHasSubmitted(false);
    }, [
        localizedContactUrl
    ]);
    const activateSiteHandler = (0, $iSvIT.useCallback)(async (signupId, privacyPolicy)=>{
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setRecaptchFailedToLoad(true);
            return;
        }
        setRecaptchFailedToLoad(false);
        const localeData = await signupClient.getConsentConfig();
        const testingPurposes = (0, $jgJpJ.isTestTenantByName)(siteName);
        const signupContext = (0, $jgJpJ.getSignupContext)({
            productKey: productKey,
            testingPurposes: testingPurposes,
            signupId: signupId,
            search: location.search
        });
        const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
        let signupContextString = JSON.stringify(signupContext);
        if (signupContextString.length > MAX_SIGNUP_CONTEXT_LENGTH) signupContextString = "{}";
        const ccpProducts = (0, $jgJpJ.mapProductKeyAndEditionToCcpProduct)({
            productKey: productKey,
            edition: edition
        });
        // service collections with a primaryCollectionProduct prioritize that product first
        const childProductsForPriorityActivation = productKey === (0, $jgJpJ.ProductKey).SERVICE_COLLECTION && primaryCollectionProduct ? [
            primaryCollectionProduct
        ] : [];
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(user.email || "", executeRecaptcha);
        (0, $jgJpJ.ufoEventNewSiteN2NSubmit).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SiteActivationProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "site-activation");
            showRecaptchaFormError();
            return;
        }
        // Set experiment metadata before starting UFO event for GraphQL webhook setup
        (0, $jgJpJ.ufoEventGraphQLWebhookSetup).setCustomData({
            webPlatform: "site-activation"
        });
        var _localeData_locale;
        // get consents
        const consent = (0, $jgJpJ.getConsents)((_localeData_locale = localeData.locale) !== null && _localeData_locale !== void 0 ? _localeData_locale : "US-VA", localeData.localeRequiresMarketingCommunicationOptIn, privacyPolicy);
        const response = await signupClient.activateProduct({
            displayName: user.name,
            email: user.email || "",
            ccpProducts: [
                ccpProducts
            ],
            childProductsForPriorityActivation: childProductsForPriorityActivation,
            siteName: siteName,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            useCcpPlatform: platform === "ccp",
            consent: consent,
            platform: platform,
            signupContext: signupContextString,
            isNewUser: productKey === (0, $jgJpJ.ProductKey).JIRA_SOFTWARE || isNewUser,
            gRecaptchaResponse: gRecaptchaResponse,
            testingPurposes: testingPurposes,
            signupId: signupId,
            transactionAccountId: selectedTransactionAccountId
        });
        const redirectUrl = (0, $jgJpJ.getConfirmationPageUrl)({
            locale: intl.locale,
            productKey: productKey,
            response: response,
            siteName: siteName,
            signupId: signupId,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        window.location.assign(redirectUrl);
    }, [
        executeRecaptcha,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        signupClient,
        siteName,
        primaryCollectionProduct,
        location.search,
        productKey,
        edition,
        user,
        platform,
        isNewUser,
        intl.locale,
        createAnalyticsEvent,
        selectedTransactionAccountId
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (profile.requestInProgress || !analyticsClient) return;
        (0, $jgJpJ.trackSiteActivationViewed)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: transactionAccounts.length
        });
    }, [
        analyticsClient,
        cohort,
        createAnalyticsEvent,
        companyType,
        dataFoundationsActionSubjectId,
        domainType,
        edition,
        productKey,
        profile.requestInProgress,
        userType
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const ufoSubmitEvent = showSitePicker ? (0, $jgJpJ.ufoEventExistingSiteN2ESubmit) : (0, $jgJpJ.ufoEventNewSiteN2NSubmit);
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) ufoSubmitEvent.failure({
            customData: {
                reactComponent: "SiteActivationContextProvider",
                analyticsEvent: "errored",
                recaptchaRetryTimeRemainingSecond: 0,
                siteType: showSitePicker ? "existing-site" : "new-site"
            },
            error: new Error("Recaptcha retry failed")
        });
        if (recaptchaFailedToLoad) activateSiteHandler().then(()=>{
            ufoSubmitEvent.success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            showRecaptchaFormError();
            ufoSubmitEvent.failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        activateSiteHandler,
        executeRecaptcha,
        localizedContactUrl,
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        showSitePicker
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    // eslint-disable-next-line complexity
    const activateSite = async ({ privacyPolicy: privacyPolicy })=>{
        var _profile_cohorts;
        setHasSubmitted(true);
        sessionStorage.setItem("provisioningStartTime", `${Date.now()}`);
        // Start UFOs to begin duration metrics for signup submit
        (0, $jgJpJ.ufoEventNewSiteN2NSubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        const ufoLogs = [
            ...$ea14a84f25ad216e$var$ufoBaseLogs,
            {
                name: "method:activateSite"
            }
        ];
        // user must be logged in
        if (!user.isUserLoggedIn) return;
        // Generate a signup ID and add it to all the events in this flow.
        // This id is used to stitch together a view of the end-to-end
        // provisioning experience, all the way to landing in product.
        const signupId = (0, $cGDYS.default)();
        const isN2N = !showSitePicker && !sitePickerValue;
        const domainType = profile && ((_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.domainType);
        (0, $jgJpJ.trackSignupStarted)(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType);
        // handle site picker submit
        if (showSitePicker) {
            if (sitePickerValue) {
                var _sitePickerValue_products_;
                const isGateEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).siteActivationUpgradableProductsInSignup);
                const upgradableProduct = sitePickerValue.products.find((product)=>[
                        product.productKey,
                        product.partOfCollection
                    ].includes(productKey) && product.productEdition === "free");
                const isUpgradeEligibleUserWithUpgradableProduct = cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER && sitePickerValue.products.length > 0;
                const billingSystem = isGateEnabled ? (_sitePickerValue_products_ = sitePickerValue.products[0]) === null || _sitePickerValue_products_ === void 0 ? void 0 : _sitePickerValue_products_.billingSourceSystem : upgradableProduct === null || upgradableProduct === void 0 ? void 0 : upgradableProduct.billingSourceSystem;
                if (isGateEnabled ? isUpgradeEligibleUserWithUpgradableProduct : Boolean(upgradableProduct)) {
                    // send to adminhub
                    const redirectUrl = await (0, $jgJpJ.getAdminHubUpgradeProductUrl)(sitePickerValue, productKey, edition);
                    createAnalyticsEvent({
                        eventName: "signupUpgrade",
                        eventComponent: "button",
                        billingSystem: billingSystem,
                        event: "clicked",
                        eventType: "ui",
                        action: "upgrade"
                    }).fire("signup");
                    window.location.assign(redirectUrl);
                    return;
                }
                try {
                    // Check for Shadow IT authorization.
                    await signupClient.getActivationAuthorization({
                        productKeys: [
                            productKey
                        ],
                        productEdition: edition,
                        cloudId: sitePickerValue.cloudId,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName
                    });
                    const crossFlowActivationUrl = (0, $jgJpJ.getCrossFlowActivationUrl)({
                        cloudId: sitePickerValue.cloudId,
                        edition: edition,
                        productKey: primaryCollectionProduct !== null && primaryCollectionProduct !== void 0 ? primaryCollectionProduct : productKey,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName
                    });
                    (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).success({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "succeeded",
                            siteType: "existing-site"
                        }
                    });
                    (0, $jgJpJ.trackSitePickerSubmit)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        targetCloudId: sitePickerValue.cloudId,
                        provisionedProducts: [
                            {
                                product: productKey,
                                edition: edition
                            }
                        ],
                        signupUrl: crossFlowActivationUrl,
                        aaid: user.accountId
                    });
                    window.location.assign(crossFlowActivationUrl);
                } catch (error) {
                    (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).failure({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "errored",
                            siteType: "existing-site"
                        },
                        error: error
                    });
                    redirectToAdminHubForShadowIt(error);
                }
            }
            return;
        }
        if (isValidating) {
            const { availability: availability } = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            });
            if (availability !== "AVAILABLE") {
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
            setSiteNameValid(true);
        }
        if (!siteNameValid && !isValidating || !siteName) {
            setHasSubmitted(false); // reset to allow re-submit
            return;
        }
        (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
        if (siteName !== recommendedSiteName) (0, $jgJpJ.trackSiteNameChangedFromRecommendedSiteName)(createAnalyticsEvent, siteName, recommendedSiteName);
        let setTimeoutId;
        const interactionId = (0, $cGDYS.default)();
        (0, $jgJpJ.operateWithSignupUFOLogging)({
            interactionId: interactionId,
            interactionName: "try-cloud-signup_form-submit",
            type: "press",
            timeout: 120000,
            labelStack: [
                {
                    name: "uip"
                }
            ],
            errorContext: "error occured on signup form submit button"
        }, async ()=>Promise.race([
                new Promise((_resolve, reject)=>{
                    setTimeoutId = setTimeout(()=>{
                        reject((0, $jgJpJ.SignupUFOLoggingActionTimeoutError));
                    }, 60000);
                }),
                activateSiteHandler(signupId, privacyPolicy).finally(()=>{
                    if (setTimeoutId) clearTimeout(setTimeoutId);
                })
            ])).then(()=>{
            // SLO "good event" for N2N signup submit
            (0, $jgJpJ.ufoEventNewSiteN2NSubmit).success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: "new-site"
                }
            });
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).ACTIVATE_PRODUCT_API_SUCCESS,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$TRANSITION,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured on bxp-ui only
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured across bxp-ui and bxpkit
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                ufoLogger: ufoLogs
            });
        }).catch((error)=>{
            var _error_response_headers, _error_response;
            // SLO "bad event" for N2N signup submit
            (0, $jgJpJ.ufoEventNewSiteN2NSubmit).failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: "new-site"
                },
                error: error
            });
            redirectToAdminHubForShadowIt(error);
            const traceId = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_headers = _error_response.headers) === null || _error_response_headers === void 0 ? void 0 : _error_response_headers.get("atl-traceid");
            setValidationMessage((0, $6iHNw._)((0, $7Knp0._)({}, (0, $fBroD.messages).timeout), {
                values: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    "href-support": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: localizedContactUrl,
                            children: node
                        }),
                    "error_id": traceId ? `Trace ID: ${traceId}` : `Interaction ID: ${interactionId}`
                }
            }));
            // don't re-enable the form when there is an HTTP exception. this helps with rate-limiting
            const errorType = (0, $jgJpJ.SignupGetUFOErrorType)(error);
            if (errorType !== "http_exception") {
                // Reset form to allow re-submit
                setIsSubmitting(false);
                setHasSubmitted(false);
            }
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).ACTIVATE_PRODUCT_API_ERROR,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$TRANSITION,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured on bxp-ui only
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured across bxp-ui and bxpkit
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($ea14a84f25ad216e$export$fe5d808150ab3415.Provider, {
        value: {
            isSubmitting: isSubmitting,
            activateSite: activateSite,
            showSitePicker: showSitePicker,
            sites: sites,
            isRequestInProgress: profile.requestInProgress,
            email: user.email,
            sitePickerValue: sitePickerValue,
            setSitePickerValue: setSitePickerValue,
            setSiteNameValid: setSiteNameValid,
            siteName: siteName,
            setSiteNameValue: setSiteNameValue,
            setShowSitePicker: setShowSitePicker,
            recommendedSiteName: recommendedSiteName,
            hasSubmitted: hasSubmitted,
            setHasSubmitted: setHasSubmitted,
            validationMessageState: [
                validatationMessage,
                setValidationMessage
            ],
            isValid: isValid,
            isValidating: isValidating,
            error: error,
            isWorkspaceProduct: isWorkspaceProduct,
            selectedTransactionAccountId: selectedTransactionAccountId,
            setSelectedTransactionAccountId: setSelectedTransactionAccountId,
            primaryCollectionProduct: primaryCollectionProduct
        },
        children: children
    });
};

});
parcelRegister("fBroD", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $9f3c2e95e8688e2f$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $9f3c2e95e8688e2f$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    timeout: {
        id: "siteActivation.nameSite.error.timeout",
        defaultMessage: "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "siteActivation.nameSite.error.invalidName",
        defaultMessage: "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "siteActivation.nameSite.error.maxLength",
        defaultMessage: "That's a bit too long \u2014 try something 50 characters or less."
    },
    unavailable: {
        id: "siteActivation.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    networkError: {
        id: "siteActivation.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});

});




parcelRegister("lXhsL", function(module, exports) {

$parcel$export(module.exports, "SiteActivationSwitcher", function () { return $bca07f5e1d47addb$export$336514a242c2c5c0; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("dhiHj");
var $fOAR4 = parcelRequire("fOAR4");
var $h0Hfa = parcelRequire("h0Hfa");
var $lXpJc = parcelRequire("lXpJc");
var $9aW3V = parcelRequire("9aW3V");
var $4bUDl = parcelRequire("4bUDl");
const $bca07f5e1d47addb$export$336514a242c2c5c0 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}), ManagedUser: ManagedUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $h0Hfa.ManagedUser), {}), NewUser: NewUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXpJc.NewUser), {}), WeekOneUser: WeekOneUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9aW3V.WeekOneUser), {}), UpgradeEligibleUser: UpgradeEligibleUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4bUDl.UpgradeEligibleUser), {}), CurrentProductUser: CurrentProductUser, UpliftEligibleUser: UpliftEligibleUser, CrossflowEligibleUser: CrossflowEligibleUser })=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === (0, $iMdoL.COHORTS).MANAGED_USER && ManagedUser) return ManagedUser;
    if (cohort === (0, $iMdoL.COHORTS).WEEK_ONE_USER && WeekOneUser) return WeekOneUser;
    if (cohort === (0, $iMdoL.COHORTS).CURRENT_PRODUCT_USER && CurrentProductUser) return CurrentProductUser;
    if (cohort === (0, $iMdoL.COHORTS).NEW_USER && NewUser) return NewUser;
    if (cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) return UpgradeEligibleUser;
    if (cohort === (0, $iMdoL.COHORTS).UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) return UpliftEligibleUser;
    if (cohort === (0, $iMdoL.COHORTS).CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) return CrossflowEligibleUser;
    return ExistingUser;
};

});
parcelRegister("dhiHj", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("jqbIe")).Dropdown; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("h0Hfa")).ManagedUser; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("9aW3V")).WeekOneUser; });
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("4bUDl")).UpgradeEligibleUser; });
parcelRequire("8HNBH");
parcelRequire("hIYuQ");
parcelRequire("eQore");
parcelRequire("cpLkq");
parcelRequire("6ZAeC");
parcelRequire("bavlo");

});
parcelRegister("8HNBH", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("jqbIe")).Dropdown; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SiteNameInput", function () { return (parcelRequire("hXsC1")).SiteNameInput; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });
$parcel$export(module.exports, "SiteToggleButton", function () { return (parcelRequire("bI30y")).SiteToggleButton; });
$parcel$export(module.exports, "Label", function () { return (parcelRequire("511ro")).Label; });
parcelRequire("jqbIe");
parcelRequire("aw7DU");
parcelRequire("fwI3y");
parcelRequire("hXsC1");
parcelRequire("gNKPy");
parcelRequire("bI30y");
parcelRequire("fsv0y");
parcelRequire("511ro");

});
parcelRegister("jqbIe", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $d6e0fac41afc499d$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $c9Cls = parcelRequire("c9Cls");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $hFZ05 = parcelRequire("hFZ05");
const $d6e0fac41afc499d$export$931cbfb6bfb85fc = ({ sites: sites })=>{
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue, isSubmitting: isSubmitting, isRequestInProgress: isRequestInProgress, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "adg4-site-picker",
        className: (0, $esG4f.default)([
            "_1heubzd7 _125x1syg _62vcmccc _1mmsglyw _pqyq183y _84yz183y _tnizyh40 _101oyh40 _9fwgmccc _1n42bzd7 _19hkbzd7 _1700grf3 _156ugrf3 _16z5grf3 _iazigrf3 _1ybr1crf _uy3o19bv"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            defaultValue: sites[0],
            isDisabled: isSubmitting,
            id: "site-picker-field",
            name: "site-picker-field",
            testId: "site-picker-field",
            label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect4bzd7 _1wybdlk8 _k48p4jg8 _vwz4gktf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: isWorkspaceProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "siteActivation.yourWorkspace",
                    defaultMessage: "Your workspace"
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "WacSignupForm.siteNameN2ELabel",
                    defaultMessage: "Your site"
                })
            }),
            children: (_param)=>/*#__PURE__*/ {
                var { fieldProps: { id: id } } = _param, rest = (0, $akGnX._)(_param.fieldProps, [
                    "id"
                ]);
                return (0, $loA2J.jsx)((0, $c9Cls.default), (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                    inputId: id,
                    options: sites,
                    getOptionLabel: (option)=>option.url.replace("https://", ""),
                    getOptionValue: (option)=>option.cloudId,
                    value: sitePickerValue,
                    onChange: (newValue)=>setSitePickerValue(newValue !== null && newValue !== void 0 ? newValue : sites[0]),
                    isLoading: isRequestInProgress,
                    isSearchable: false,
                    styles: {
                        menu: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                fontSize: (0, $jgJpJ.fontSize).md
                            }),
                        valueContainer: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                fontSize: (0, $jgJpJ.fontSize).md,
                                paddingTop: "8px",
                                paddingRight: "6px",
                                paddingBottom: "8px",
                                paddingLeft: "6px"
                            }),
                        singleValue: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                margin: 0
                            })
                    }
                }));
            }
        })
    });
};
const $d6e0fac41afc499d$var$labelCss = null;
const $d6e0fac41afc499d$var$inputAndLabelStyles = null;

});

parcelRegister("aw7DU", function(module, exports) {

$parcel$export(module.exports, "IsValidOrLoading", function () { return $b973c0a9df3b00b7$export$71ec10810b978f7e; });

var $loA2J = parcelRequire("loA2J");

var $bDTBs = parcelRequire("bDTBs");

var $53DZ3 = parcelRequire("53DZ3");

var $9gh2a = parcelRequire("9gh2a");

var $kwHar = parcelRequire("kwHar");
const $b973c0a9df3b00b7$export$71ec10810b978f7e = ({ isValidating: isValidating, siteNameValue: siteNameValue, validationMessage: validationMessage })=>{
    if (siteNameValue === "") return null;
    if (isValidating) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
        size: "small",
        testId: "spinner"
    });
    if (validationMessage) return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53DZ3))), {
        label: "warning",
        primaryColor: (0, $kwHar.default)("color.border.danger")
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
        label: "success",
        primaryColor: (0, $kwHar.default)("color.border.success")
    });
};

});

parcelRegister("fwI3y", function(module, exports) {

$parcel$export(module.exports, "ReturnToProduct", function () { return $5f91fa891cf867a6$export$1cac7f8e3baae627; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");
const $5f91fa891cf867a6$export$1cac7f8e3baae627 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}), sites: sites })=>{
    const location = (0, $lrVTP.useLocation)();
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("createNew") === "true";
    }, [
        location.search
    ]);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const sitesWithCurrentProduct = (0, $iMdoL.useSitesWithCurrentProduct)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const { user: { email: email } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    if (sites === undefined) sites = sitesWithCurrentProduct;
    const goToProductButtonText = isWorkspaceProduct ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$5f91fa891cf867a6$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contactExpandGoToSiteNamingScreen",
                    attributes: {
                        productName: product === null || product === void 0 ? void 0 : product.name
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$5f91fa891cf867a6$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $5f91fa891cf867a6$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-product",
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulp7vkz"
                        ]),
                        children: sites === null || sites === void 0 ? void 0 : sites.map((site, index)=>/*#__PURE__*/ {
                            var _product_key;
                            return (0, $loA2J.jsxs)("a", {
                                href: $5f91fa891cf867a6$var$getProductUrl({
                                    url: site.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                }),
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for event to fire
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "contactExpandClickReturnToProductButton",
                                        attributes: {
                                            productName: productName
                                        }
                                    }).fire();
                                    var _product_key;
                                    window.location.href = $5f91fa891cf867a6$var$getProductUrl({
                                        url: site.url,
                                        productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                    });
                                },
                                className: (0, $esG4f.default)([
                                    "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                                ]),
                                style: {
                                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1hap _ect4bzd7 _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                ]),
                                                style: {
                                                    "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700")),
                                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                                },
                                                children: site.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_p12fmgvx"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                            variant: "primary",
                                            size: "small",
                                            color: "blue",
                                            children: goToProductButtonText
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $5f91fa891cf867a6$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $5f91fa891cf867a6$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: exitView,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $5f91fa891cf867a6$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $5f91fa891cf867a6$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $5f91fa891cf867a6$var$containerCss = null;
const $5f91fa891cf867a6$var$goToExistingWorkspaceLinkCss = null;
const $5f91fa891cf867a6$var$goToExistingWorkspaceMessageCss = null;
const $5f91fa891cf867a6$var$switchAccountSubheader = null;
const $5f91fa891cf867a6$var$contentCss = null;
const $5f91fa891cf867a6$var$createNewWorkspaceMessageCss = null;
const $5f91fa891cf867a6$var$createNewWorkspaceLinkCss = null;
const $5f91fa891cf867a6$var$boxContainerCss = null;
const $5f91fa891cf867a6$var$siteBoxCss = null;
const $5f91fa891cf867a6$var$goToProductButtonCss = null;
const $5f91fa891cf867a6$var$bold = null;
const $5f91fa891cf867a6$var$siteCss = null;
const $5f91fa891cf867a6$var$siteNameCss = null;
const $5f91fa891cf867a6$var$emailCss = null;
const $5f91fa891cf867a6$var$switchAccountLinkCss = null;

});
parcelRegister("hIYuQ", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
parcelRequire("fOAR4");

});
parcelRegister("fOAR4", function(module, exports) {

$parcel$export(module.exports, "ExistingUser", function () { return $4b6f32c4c2db1836$export$706672462bf25099; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $ajeUJ = parcelRequire("ajeUJ");
const $4b6f32c4c2db1836$export$706672462bf25099 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $ajeUJ.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("ajeUJ", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $5c194a071654b57f$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $9iWJ8 = parcelRequire("9iWJ8");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $gNKPy = parcelRequire("gNKPy");
var $hXsC1 = parcelRequire("hXsC1");
var $bI30y = parcelRequire("bI30y");

var $9yDhn = parcelRequire("9yDhn");

var $dfFLm = parcelRequire("dfFLm");
const $5c194a071654b57f$export$7c6e2c02157bb7d2 = ({ SitePicker: SitePicker = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {}), SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bI30y.SiteToggleButton), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker, activateSite: activateSite, sites: sites } = (0, $hFZ05.useSiteActivationContext)();
    const sitePickerEnabled = sites.length > 0 && SitePicker && SiteToggleButton; // if the site picker is not enabled, let context know it is not showing
    (0, $iSvIT.useEffect)(()=>{
        if (!sitePickerEnabled && showSitePicker) setShowSitePicker(false);
    }, [
        sitePickerEnabled
    ]);
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dfFLm.ExistingSitesSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
     // Only show if more than one transaction account, creating a new site, and experiment is enabled
    const gwp8627SignupTransactionSelectorExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp8627SignupTransactionSelector);
    const showTxaSelector = !showSitePicker && gwp8627SignupTransactionSelectorExperiment && gwp8627SignupTransactionSelectorExperiment.type === "enrolled" && gwp8627SignupTransactionSelectorExperiment.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "existing-sites-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            showSitePicker && sitePickerEnabled ? SitePicker : SiteNameInput,
                            sitePickerEnabled && SiteToggleButton
                        ]
                    }),
                    showTxaSelector && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9yDhn.TransactionAccountSelector), {}),
                    SubmitButton,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $5c194a071654b57f$var$containerCss = null;

});
parcelRegister("9yDhn", function(module, exports) {

$parcel$export(module.exports, "TransactionAccountSelector", function () { return $00c83a0f1b31a6b0$export$24b383d12e62d81f; });
/* transaction-account-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $adeWn = parcelRequire("adeWn");

var $c9Cls = parcelRequire("c9Cls");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $511ro = parcelRequire("511ro");
const $00c83a0f1b31a6b0$var$container = null;
const $00c83a0f1b31a6b0$export$24b383d12e62d81f = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $iMdoL.useUserContext)();
    const { isSubmitting: isSubmitting, selectedTransactionAccountId: selectedTransactionAccountId, setSelectedTransactionAccountId: setSelectedTransactionAccountId } = (0, $hFZ05.useSiteActivationContext)();
    const handleSelectionChange = (value)=>{
        if (value) setSelectedTransactionAccountId(value.value);
    };
    const selectedValue = transactionAccounts.find((account)=>account.id === selectedTransactionAccountId);
    const transactionAccountLabel = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "siteActivation.transactionAccountSelectorLabel",
        defaultMessage: "Billing Account"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "transaction-account-select-container",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpyh40"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $adeWn.Label), {
                htmlFor: "transaction-account-select",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
                    children: transactionAccountLabel
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $c9Cls.default), {
                inputId: "transaction-account-select",
                options: transactionAccounts.map((transactionAccount)=>({
                        label: transactionAccount.number,
                        value: transactionAccount.id
                    })),
                value: selectedValue ? {
                    label: selectedValue.number,
                    value: selectedValue.id
                } : null,
                onChange: handleSelectionChange,
                isDisabled: isSubmitting,
                isRequired: true,
                styles: {
                    control: (rest)=>(0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                            borderRadius: "21px",
                            fontFamily: (0, $5ohHq.wacToken)("font.charlie.text"),
                            fontSize: "1rem",
                            padding: "0px 6px"
                        })
                }
            })
        ]
    });
};

});

parcelRegister("dfFLm", function(module, exports) {

$parcel$export(module.exports, "ExistingSitesSubmitButton", function () { return $1cc441750aaeac1c$export$795867072991ebfa; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $1cc441750aaeac1c$export$795867072991ebfa = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});
parcelRegister("fsv0y", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $4a5e74e197d41ade$export$8b7b7cdfb85d78c5; });
/* submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $91nJf = parcelRequire("91nJf");

var $hFZ05 = parcelRequire("hFZ05");
const $4a5e74e197d41ade$export$8b7b7cdfb85d78c5 = ({ submitMessage: submitMessage })=>{
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_14hp1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
            isDisabled: isSubmitting || hasSubmitted,
            isLoading: isSubmitting || hasSubmitted,
            type: "submit",
            dataEventProps: {
                "data-product-key": "jira",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "siteName",
                "data-label": "continue-or-agree",
                "data-label-english": submitMessage,
                "data-track-event": "jira-site-name.site-name-form.atlas-66195.site-name"
            },
            children: submitMessage
        })
    });
};
const $4a5e74e197d41ade$var$buttonStyles = null;

});






parcelRegister("hXsC1", function(module, exports) {

$parcel$export(module.exports, "SiteNameInput", function () { return $2de8f145ecfa9aee$export$42a3d109cf521241; });
/* site-name-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $dwSjs = parcelRequire("dwSjs");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $hSQrG = parcelRequire("hSQrG");

var $hFZ05 = parcelRequire("hFZ05");

var $fBroD = parcelRequire("fBroD");

var $aw7DU = parcelRequire("aw7DU");

var $511ro = parcelRequire("511ro");
const $2de8f145ecfa9aee$export$42a3d109cf521241 = ({ inputLabel: inputLabel })=>{
    (0, $hSQrG.useRecommendedSiteName)({
        onError: console.error
    }); // onError catches errors from endpoint
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, isSubmitting: isSubmitting, validationMessageState: [validationMessage, setValidationMessage], isValid: isValid, isValidating: isValidating, error: error, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const siteNameAddressSuffix = (0, $jgJpJ.isProduction)() ? ".atlassian.net" : ".jira-dev.com";
    (0, $iSvIT.useEffect)(()=>{
        switch(error){
            case (0, $dwSjs.ErrorType).NO_ERROR:
                setValidationMessage(undefined);
                break;
            case (0, $dwSjs.ErrorType).INVALID_NAME:
                setValidationMessage((0, $fBroD.messages).invalidName);
                break;
            case (0, $dwSjs.ErrorType).MAXIMUM_LENGTH:
                setValidationMessage((0, $fBroD.messages).maxLength);
                break;
            case (0, $dwSjs.ErrorType).UNAVAILABLE:
                setValidationMessage((0, $fBroD.messages).unavailable);
                break;
            case (0, $dwSjs.ErrorType).NETWORK_ERROR:
                setValidationMessage((0, $fBroD.messages).networkError);
                break;
        }
    }, [
        error,
        setValidationMessage
    ]);
    const label = (inputLabel !== null && inputLabel !== void 0 ? inputLabel : isWorkspaceProduct) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "siteActivation.yourWorkspace",
        defaultMessage: "Your workspace"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "accountActivation.nameSite.inputSiteNameLabel",
        defaultMessage: "Your site"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "adg4-site-name-input",
        className: (0, $esG4f.default)([
            "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_8xzq121t _1rwq121t _r64ckb7n _1ljbkb7n _17eaf1ug _1heubzd7 _125x1j6v _5hv91wug _1d6jidpf _1mmsglyw"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                "aria-required": true,
                isDisabled: isSubmitting,
                name: "site-name",
                label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
                    children: label
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            isValid && "_1lo6qn1y",
                            validationMessage !== undefined && "_1lo61wfy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({
                                type: "text",
                                autoComplete: "on",
                                testId: "site-name-input"
                            }, fieldProps), {
                                value: siteName,
                                onChange: (e)=>{
                                    setSiteNameValue(e.currentTarget.value);
                                    fieldProps.onChange(e);
                                },
                                "aria-describedby": validationMessage ? "site-name-error" : undefined,
                                elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_4cvr1h6o _syaztqnc _1e0c1txw _1wyb1j6v _k48p1nn1 _1bahesu3 _y4tiftgi _1bsb1wug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: (0, $esG4f.default)([
                                                "_bfhku67f _1wyb8oy7 _y4tiftgi _o5721q9c"
                                            ]),
                                            style: {
                                                "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
                                            },
                                            children: siteNameAddressSuffix
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $aw7DU.IsValidOrLoading), {
                                            isValidating: isValidating,
                                            siteNameValue: siteName,
                                            validationMessage: validationMessage
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                id: "site-name-error",
                                role: "alert",
                                className: (0, $esG4f.default)([
                                    "_syaz1tmw _1wyboqnp _43ds17la _59381r31 _yha28stv _1nmznqa1",
                                    validationMessage && "_1pfhi2wt"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                },
                                children: validationMessage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, validationMessage))
                            })
                        ]
                    })
            })
        })
    });
};
const $2de8f145ecfa9aee$var$inputInvalidCss = null;
const $2de8f145ecfa9aee$var$inputValidCss = null;
const $2de8f145ecfa9aee$var$fieldWrapperCss = null;
const $2de8f145ecfa9aee$var$siteNameAfterLabelCss = null;
const $2de8f145ecfa9aee$var$siteNameAfterCss = null;
const $2de8f145ecfa9aee$var$siteNameErrorCss = null;
const $2de8f145ecfa9aee$var$siteNameErrorVisibleCss = null;
const $2de8f145ecfa9aee$var$inputAndLabelStyles = null;

});
parcelRegister("511ro", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $3ea5cc307a19c6ef$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $3ea5cc307a19c6ef$var$labelCss = null;
const $3ea5cc307a19c6ef$export$b04be29aa201d4f5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_ect4bzd7 _1wybdlk8 _k48p4jg8 _vwz4gktf"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: children
    });
};

});


parcelRegister("gNKPy", function(module, exports) {

$parcel$export(module.exports, "SitePicker", function () { return $41d6367d1432a1f8$export$7793ee10ee71ac54; });
/* site-picker.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $511ro = parcelRequire("511ro");
var $jqbIe = parcelRequire("jqbIe");
const $41d6367d1432a1f8$export$7793ee10ee71ac54 = ()=>{
    var _sites_;
    const { sites: sites, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const label = /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
        children: isWorkspaceProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "siteActivation.yourWorkspace",
            defaultMessage: "Your workspace"
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "siteActivation.siteNameSitePickerLabel",
            defaultMessage: "Your site"
        })
    });
    if (sites.length === 1) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1mmsglyw _11ur183y _1rys1rga _a5o8xv17 _1tgt1kw7 _1cgv7vkz _1b7z1nn1 _jxt4bzd7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszr7vkz"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            isDisabled: true,
            name: "site-picker-field",
            id: "site-picker-field",
            testId: "site-picker-field",
            label: label,
            defaultValue: (_sites_ = sites[0]) === null || _sites_ === void 0 ? void 0 : _sites_.url.replace("https://", ""),
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $7Knp0._)({}, fieldProps))
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jqbIe.Dropdown), {
        sites: sites
    });
};
const $41d6367d1432a1f8$var$inputCss = null;

});

parcelRegister("bI30y", function(module, exports) {

$parcel$export(module.exports, "SiteToggleButton", function () { return $8624e3cd529e56de$export$3bfd0ee4a8c5295a; });
/* site-toggle-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $jgJpJ = parcelRequire("jgJpJ");

var $hFZ05 = parcelRequire("hFZ05");
const $8624e3cd529e56de$export$3bfd0ee4a8c5295a = ()=>{
    const intl = (0, $f6qj2.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    const toggleYourSiteButtonText = showSitePicker ? isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.startNewWorkspaceButton",
        defaultMessage: "Start a new workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.useExistingWorkspaceButton",
        defaultMessage: "Use an existing workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
        appearance: "link",
        onClick: ()=>setShowSitePicker(!showSitePicker),
        className: (0, $esG4f.default)([
            "_18zrgrf3"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _1e0c1txw _1wyb8oy7 _zulp1y44 _syazrbzz"
            ]),
            style: {
                "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
            },
            children: [
                toggleYourSiteButtonText,
                /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    "aria-hidden": true,
                    fill: "currentColor",
                    height: "8",
                    width: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z"
                    })
                })
            ]
        })
    });
};
const $8624e3cd529e56de$var$buttonCss = null;
const $8624e3cd529e56de$var$buttonInnerCss = null;

});


parcelRegister("eQore", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("h0Hfa")).ManagedUser; });
parcelRequire("h0Hfa");

});
parcelRegister("h0Hfa", function(module, exports) {

$parcel$export(module.exports, "ManagedUser", function () { return $b944039ed1bd1919$export$fcb76302df2c072d; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");

var $8ZEkt = parcelRequire("8ZEkt");
const $b944039ed1bd1919$export$fcb76302df2c072d = ()=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const sites = (0, $iMdoL.useManagingOrgUserSites)();
    const { profile: profile, product: product } = (0, $iMdoL.useUserContext)();
    const orgId = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$b944039ed1bd1919$var$goToExistingWorkspace(str, clickGoToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>$b944039ed1bd1919$var$goToSiteNaming(str, clickGoToSiteNamingScreen)
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToExistingWorkspaceMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8ZEkt.SitesList), {
                    sites: sites
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToSiteNamingMessage
                })
            ]
        })
    }) : null;
};
const $b944039ed1bd1919$var$goToSiteNaming = (str, clickGoToSiteNamingScreen)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        onClick: clickGoToSiteNamingScreen,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $b944039ed1bd1919$var$goToExistingWorkspace = (str, clickGoToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        onClick: clickGoToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $b944039ed1bd1919$var$containerCss = null;
const $b944039ed1bd1919$var$goToLinkCss = null;
const $b944039ed1bd1919$var$goToMessageCss = null;

});
parcelRegister("8ZEkt", function(module, exports) {

$parcel$export(module.exports, "SitesList", function () { return $66bcb8a798700f34$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $66bcb8a798700f34$export$e2789664959efdd3 = ({ sites: sites })=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, product: product, user: { email: email } } = (0, $iMdoL.useUserContext)();
    const orgId = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $66bcb8a798700f34$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                        href: $66bcb8a798700f34$var$getIdentityUrl({
                            url: url,
                            productKey: product === null || product === void 0 ? void 0 : product.key
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: product === null || product === void 0 ? void 0 : product.name
                                }
                            }).fire();
                            window.location.href = $66bcb8a798700f34$var$getIdentityUrl({
                                url: url,
                                productKey: product === null || product === void 0 ? void 0 : product.key
                            });
                        },
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _179rzgxb _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: product === null || product === void 0 ? void 0 : product.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_syaz131l _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: product === null || product === void 0 ? void 0 : product.description
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $66bcb8a798700f34$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $66bcb8a798700f34$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $jgJpJ.ProductKey).DEVAI:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $66bcb8a798700f34$var$containerCss = null;
const $66bcb8a798700f34$var$switchAccountSubheader = null;
const $66bcb8a798700f34$var$sitesListCss = null;
const $66bcb8a798700f34$var$siteBoxCss = null;
const $66bcb8a798700f34$var$productNameCss = null;
const $66bcb8a798700f34$var$siteCss = null;
const $66bcb8a798700f34$var$siteNameCss = null;
const $66bcb8a798700f34$var$goToSiteButtonContainerCss = null;
const $66bcb8a798700f34$var$emailCss = null;
const $66bcb8a798700f34$var$switchAccountLinkCss = null;

});



parcelRegister("cpLkq", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
parcelRequire("lXpJc");

});
parcelRegister("lXpJc", function(module, exports) {

$parcel$export(module.exports, "NewUser", function () { return $87cbd8392ad36d29$export$17cbb676e2e98676; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $448Ia = parcelRequire("448Ia");
const $87cbd8392ad36d29$export$17cbb676e2e98676 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $448Ia.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("448Ia", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $b728d3cf0b016f5d$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $hFZ05 = parcelRequire("hFZ05");

var $hXsC1 = parcelRequire("hXsC1");

var $4zAGe = parcelRequire("4zAGe");

var $dJ9cc = parcelRequire("dJ9cc");
const $b728d3cf0b016f5d$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), HelperText: HelperText = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4zAGe.HelperText), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { activateSite: activateSite } = (0, $hFZ05.useSiteActivationContext)();
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ9cc.NewUserSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "new-user-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            SiteNameInput,
                            HelperText
                        ]
                    }),
                    SubmitButton,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $b728d3cf0b016f5d$var$containerCss = null;

});
parcelRegister("4zAGe", function(module, exports) {

$parcel$export(module.exports, "HelperText", function () { return $bf555ed982d4096e$export$7bc3de131d90901c; });
/* helper-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
const $bf555ed982d4096e$export$7bc3de131d90901c = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const text = isWorkspaceProduct ? formatMessage({
        id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
        defaultMessage: "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
    }) : formatMessage({
        id: "siteActivation.nameSite.inputSiteNameHelperText",
        defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syazalr3 _1wyboqnp _vwz4bs82 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: text
    });
};
const $bf555ed982d4096e$var$helperTextCss = null;

});

parcelRegister("dJ9cc", function(module, exports) {

$parcel$export(module.exports, "NewUserSubmitButton", function () { return $a3f870106a879a49$export$f05369598c89e38f; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $a3f870106a879a49$export$f05369598c89e38f = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});




parcelRegister("6ZAeC", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("9aW3V")).WeekOneUser; });
parcelRequire("9aW3V");

});
parcelRegister("9aW3V", function(module, exports) {

$parcel$export(module.exports, "WeekOneUser", function () { return $8640fa6c758a5637$export$16be3dbbc731576d; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");
parcelRequire("eLaKk");
var $jOry7 = parcelRequire("jOry7");
const $8640fa6c758a5637$export$16be3dbbc731576d = ()=>{
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$8640fa6c758a5637$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = (product === null || product === void 0 ? void 0 : product.key) === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $jOry7.ReturnToExistingProduct), {
        productKeyForExpand: (product === null || product === void 0 ? void 0 : product.key) || (0, $jgJpJ.ProductKey).JIRA_SOFTWARE,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: product === null || product === void 0 ? void 0 : product.name
                }
            }).fire();
        }
    });
};
const $8640fa6c758a5637$var$containerCss = null;
const $8640fa6c758a5637$var$goToExistingWorkspaceLinkCss = null;
const $8640fa6c758a5637$var$goToExistingWorkspaceMessageCss = null;
const $8640fa6c758a5637$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: str
    });

});
parcelRegister("eLaKk", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return (parcelRequire("jOry7")).ReturnToExistingProduct; });
parcelRequire("jOry7");

});
parcelRegister("jOry7", function(module, exports) {

$parcel$export(module.exports, "ReturnToExistingProduct", function () { return $68b65d8ffbf43d63$export$ba7c22a9ce02f49f; });
/* return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
const $68b65d8ffbf43d63$export$ba7c22a9ce02f49f = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $iMdoL.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { user: { email: email } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const goToProductButtonText = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: exitView,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    var _product_key;
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $68b65d8ffbf43d63$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq"
                        ]),
                        style: {
                            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                            href: $68b65d8ffbf43d63$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                var _product_key;
                                window.location.href = $68b65d8ffbf43d63$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                });
                            },
                            className: (0, $esG4f.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_syaz1hap _ect4bzd7 _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                            ]),
                                            style: {
                                                "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700")),
                                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $68b65d8ffbf43d63$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $68b65d8ffbf43d63$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $68b65d8ffbf43d63$var$switchAccountSubheader = null;
const $68b65d8ffbf43d63$var$containerCss = null;
const $68b65d8ffbf43d63$var$contentCss = null;
const $68b65d8ffbf43d63$var$createNewWorkspaceMessageCss = null;
const $68b65d8ffbf43d63$var$createNewWorkspaceLinkCss = null;
const $68b65d8ffbf43d63$var$boxContainerCss = null;
const $68b65d8ffbf43d63$var$siteBoxCss = null;
const $68b65d8ffbf43d63$var$bold = null;
const $68b65d8ffbf43d63$var$siteCss = null;
const $68b65d8ffbf43d63$var$siteNameCss = null;
const $68b65d8ffbf43d63$var$emailCss = null;
const $68b65d8ffbf43d63$var$switchAccountLinkCss = null;

});




parcelRegister("bavlo", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("4bUDl")).UpgradeEligibleUser; });
parcelRequire("4bUDl");

});
parcelRegister("4bUDl", function(module, exports) {

$parcel$export(module.exports, "UpgradeEligibleUser", function () { return $8e7faf1a5ddb3ab3$export$31213096ab10a3ce; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $1WTin = parcelRequire("1WTin");
const $8e7faf1a5ddb3ab3$export$31213096ab10a3ce = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1WTin.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("1WTin", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $f566390ee8645ce2$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $hXsC1 = parcelRequire("hXsC1");
var $gNKPy = parcelRequire("gNKPy");
var $bI30y = parcelRequire("bI30y");

var $11F1Y = parcelRequire("11F1Y");
const $f566390ee8645ce2$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), SitePicker: SitePicker = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bI30y.SiteToggleButton), {}), SubmitButton: SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $11F1Y.UpgradeEligibleSubmitButton), {}) })=>{
    const { activateSite: activateSite, showSitePicker: showSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSite,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "upgrade-eligible-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            showSitePicker ? SitePicker : SiteNameInput,
                            SiteToggleButton
                        ]
                    }),
                    SubmitButton
                ]
            }))
    });
};
const $f566390ee8645ce2$var$containerCss = null;

});
parcelRegister("11F1Y", function(module, exports) {

$parcel$export(module.exports, "UpgradeEligibleSubmitButton", function () { return $562dcc9badb6c755$export$9143452c910a3be3; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");

var $fsv0y = parcelRequire("fsv0y");
const $562dcc9badb6c755$export$9143452c910a3be3 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { showSitePicker: showSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    const submitMessage = showSitePicker ? formatMessage({
        id: "WacSignupForm.upgradeButtonText",
        defaultMessage: "Upgrade now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});









//# sourceMappingURL=confluence-software-anchor-lp-automation.b8e388f9.js.map
